<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Industries</ion-title>
    <ion-button slot="end" fill="clear" (click)="addIndustry()">
      <ion-icon name="add-outline"></ion-icon>
      Add
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div sxPadding="medium">

    <ion-list>
      @for (industry of industries; track industry._id) {
      <ion-item detail="true" (click)="openIndustry(industry)" [hidden]="industry.parentIndustry">
        <ion-label>{{ industry.name }}</ion-label>
      </ion-item>
      }
    </ion-list>
  </div>
</ion-content>